import { Typography } from 'antd'
import React from 'react'
import { EmptyDataIcon } from 'src/assets/icons'

const TableNoRowOverlay: React.FC = () => (
  <div>
    <EmptyDataIcon />
    <Typography.Paragraph
      style={{
        marginTop: 4,
        color: 'GrayText',
      }}
    >
      {/* TODO: Fix translation of Empty data */}
      {/* {t('OverallFunctionality:table.no_data.no_data_title')} */}
      Results Not Found
    </Typography.Paragraph>
  </div>
)

export default TableNoRowOverlay
